/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import OutsideClickHandler from 'react-outside-click-handler';
import { ChevronRight } from '../../Icons';
import styles from './horizontal-select-list.module.css';

interface HorizontalSelectListProps {
    display: string;
    options: { value: number; display: number | string }[];
    handler: (value: number) => void;
}

function HorizontalSelectList({
    display,
    handler,
    options,
}: HorizontalSelectListProps): React.ReactElement<HorizontalSelectListProps> {
    const [showOptions, toggleOptions] = React.useState<boolean>(false);

    const handleList = () => {
        toggleOptions(true);
    };

    const handleClick = (value: number) => {
        handler(value);

        toggleOptions(false);
    };

    return (
        <div className={styles.HorizontalSelectList}>
            <div onClick={handleList} className={styles.HorizontalSelectListDisplay}>
                <p className={styles.HorizontalSelectListCurrent}>{display}</p>
                <div className={styles.HorizontalSelectListToggle} data-qa="horizontal-select-list-toggle">
                    <ChevronRight />
                </div>
            </div>
            {showOptions && (
                <OutsideClickHandler
                    onOutsideClick={() => {
                        toggleOptions(false);
                    }}
                >
                    <div className={styles.HorizontalSelectListOptions}>
                        {options.map(({ value, display: optionDisplay }) => (
                            <p key={`horizontal-select-list-${value}`} onClick={() => handleClick(value)}>
                                {optionDisplay}
                            </p>
                        ))}
                    </div>
                </OutsideClickHandler>
            )}
        </div>
    );
}

export default HorizontalSelectList;
